import { render, staticRenderFns } from "./versement-list-item.vue?vue&type=template&id=2cccee40&scoped=true"
import script from "./versement-list-item.vue?vue&type=script&setup=true&lang=js"
export * from "./versement-list-item.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cccee40",
  null
  
)

export default component.exports